import type { CSSProperties } from 'react';
import { cn } from '@/lib/utils';

/**
 * The brand book's long thin arrow (——→). `lineClassName` sizes the shaft,
 * e.g. `group-hover:w-20` to stretch it on hover; `lineStyle` sets a computed
 * width (it animates like the hover).
 */
export function LongArrow({
  className,
  lineClassName,
  lineStyle,
}: {
  className?: string;
  lineClassName?: string;
  lineStyle?: CSSProperties;
}) {
  return (
    <span aria-hidden="true" className={cn('flex items-center', className)}>
      <span
        className={cn(
          'h-px w-11 bg-current transition-[width] duration-500 [transition-timing-function:cubic-bezier(.2,.8,.2,1)] motion-reduce:transition-none',
          lineClassName
        )}
        style={lineStyle}
      />
      <svg
        width="10"
        height="12"
        viewBox="0 0 10 12"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.3"
        className="-ml-1.5"
      >
        <path d="M3 1l5 5-5 5" />
      </svg>
    </span>
  );
}
